export default __webpack_public_path__ + "static/novaya-black-0109b4723a12de0cb5d16b467b1a9068.png";